module.exports = __webpack_public_path__ + "static/media/i2.5ce3ee58.png";